import { render, staticRenderFns } from "./WApp.vue?vue&type=template&id=49952281&scoped=true&"
import script from "./WApp.vue?vue&type=script&lang=js&"
export * from "./WApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49952281",
  null
  
)

export default component.exports